<template>
  <div class="demo-drawer__content">
    <div class="demoForm">
      <el-form :model="requiredForm" :rules="rules" ref="ruleForm">
        <el-form-item label="解绑终端号" :label-width="formLabelWidth" prop="old_code" style="margin-bottom: 17px">
          <el-input size="medium" clearable v-model="requiredForm.old_code"
                    placeholder="请输入解绑终端号" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="新绑终端号" :label-width="formLabelWidth" prop="new_code" style="margin-bottom: 17px">
          <el-input size="medium" clearable v-model="requiredForm.new_code" placeholder="请输入新绑终端号"
                    style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="所属代理商" :label-width="formLabelWidth" prop="agent" style="margin-bottom: 17px">
          <el-input placeholder="请选择" v-model="requiredForm.agent" size="medium" :disabled="true" style="width: 400px">
            <el-button slot="append" @click="mechanismSearch">选择</el-button>
          </el-input>
        </el-form-item>
      </el-form>

    </div>
    <div class="text">
      <span style="font-size: 15px;font-weight: bold">撤机补积分备注：</span><br>
      <span style="font-size: 15px;font-weight: bold;display: block">已达标终端撤机补偿积分</span><br>
      <span style="font-size: 13px;">
        1.解绑终端必须达标<br>
        2.新绑定终端是绑定状态<br>
        3.新旧终端商户号一致<br>
        4.新绑定终端必须在代理商名下<br>
      </span>
    </div>
    <div class="demo-drawer__footer">
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      <el-button  @click="canleData">重置</el-button>
    </div>
    <!--      代理商选择表单部分-->
    <el-dialog v-if="mechanismVisible" title="配置表单" :visible.sync="mechanismVisible">
      <!--    搜索部分-->
      <el-form :inline="true" :model="dialogForm" class="demo-form-inline" style="text-align: left">
        <el-form-item label="名称">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.user_name"
              placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
              size="medium"
              clearable
              v-model="dialogForm.mobile_phone"
              placeholder="请输入"></el-input>
        </el-form-item>
          <el-button
              size="medium"
              type="primary"
              style="font-size: 12px;"
              @click="handleSearch1(dialogForm)">搜索
          </el-button>
          <el-button
              size="medium"
              style="font-size: 12px;"
              @click="handleSearch2(dialogForm)">重置
          </el-button>
      </el-form>
      <!--    表格部分-->
      <el-table
          height="250"
          :data="dialogData"
          style="width: 100%"
          :default-sort="{prop: 'date', order: 'descending'}"
          v-loading="loading2"
          border
          @row-click="singleElection">
        <el-table-column align="center" width="55">
          <template slot="header">
            <span style="cursor:pointer" @click="cancelClick2">取消</span>
          </template>
          <template slot-scope="scope">
            <el-radio class="radio" v-model="templateSelection" :label="scope.row.id"
            >{{ '&nbsp;' }}
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="id"
            label="ID"
            sortable>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="user_name"
            label="代理商名称">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="mobile_phone"
            label="代理商手机号">
        </el-table-column>
      </el-table>
      <!-- 分页部分 -->
      <el-pagination
          background
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[20,50,100,200,500,1000]"
          :page-size="page_size1"
          :total="dialogTotal"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right"
      ></el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog2">取 消</el-button>
        <el-button type="primary" @click="submitForm2">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "addIntegral",//达标撤机补积分页面
  data() {
    return {
      requiredForm: {
        old_code: "",
        new_code: "",
        receipt_user_id: '',
        agent: ""
      },
      formLabelWidth: '90px',
      rules: {
        old_code: [
          {required: true, message: '请输入开始SN号', trigger: 'blur'},
        ],
        new_code: [
          {required: true, message: '请输入结束SN号', trigger: 'blur'}
        ],
        agent: [
          {required: true, message: '请选择代理商', trigger: 'blur'}
        ]
      },
      // 代理商表单部分
      loading2: true, //列表loadding
      page_size1: 20, //表单条数
      dialogTotal: 0,  //表单总数
      dialogData: [],//表单数据
      mechanismVisible: false,//代理商选择表单开启
      dialogCodeVisible: false,//邀请码表单页面显示
      dialogForm: {//表单搜索数据
        page_size: 20,
        mobile_phone: "",//手机号码
        page: 1,
        user_name: "",//用户名称
      },
      //   当前选择的行的id
      templateSelection: "",
      //   当前选择的行的数据
      checkList: [],
    }
  },
  created() {

  },
  methods: {
    //重置
    canleData() {
      this.requiredForm.new_code = '';
      this.requiredForm.old_code = '';
      this.requiredForm.agent = '';
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 添加确定
          this.$api.post("/api/machine/unbindMachine", this.requiredForm, res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '操作成功',
                duration: 1000,
              });
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false;
        }
      });
    },
    // 代理商选择页面显示（表单显示）
    mechanismSearch() {
      this.mechanismVisible = true;
      this.getDialogData(this.dialogForm);
    },
    //表单分页
    handleCurrentChange1(page) { //当前选中页
      this.dialogForm.page = page;
      this.getDialogData(this.dialogForm);
    },
    handleSizeChange1(limit) { //表单条数
      this.dialogForm.page_size = limit;
      this.dialogForm.page = 1;
      this.getDialogData(this.dialogForm);
    },
    //表单获取数据
    getDialogData(params) { //初始化数据
      this.loading2 = true;
      this.$api.post("/api/agent/getUserAgent?page=" + params.page, params, res => {
        if (res.status == 200) {
          let dialogData = res.data;
          this.dialogTotal = dialogData.total; //总数
          this.dialogData = dialogData.list;
        } else {
          this.$message.error(res.msg);
        }
        //渲染结束后取消加载
        this.loading2 = false;
      })
    },
    //获取每行
    singleElection(row) {
      this.templateSelection = row.id;
      this.checkList = row;
    },
    //取消
    cancelClick2() {
      this.checkList = [];
      this.templateSelection = '';
    },
    // 表单确定
    submitForm2() {
      this.requiredForm.agent = this.checkList.user_name;
      this.requiredForm.receipt_user_id = this.checkList.id;
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
    },
    //表单取消
    cancelDialog2() {
      this.handleSearch2(this.dialogForm);
      this.cancelClick2();
      this.mechanismVisible = false;
    },
    //表单搜索
    handleSearch1(dialogForm) {
      dialogForm.page = 1;
      this.getDialogData(dialogForm);
    },
    //表单重置
    handleSearch2(dialogForm) {
      dialogForm.page = 1;
      dialogForm.mobile_phone = '';
      dialogForm.user_name = '';
      this.getDialogData(dialogForm);
    },
  }
}
</script>

<style scoped>
.demo-drawer__content {
  text-align: center;
}

.demoForm {
  margin-left: 33%;
  width: 500px;
}
.text{
  margin-left: 33%;
  text-align: left;
}
</style>